import { useState } from "react";

import { ASSET_DRAG_MIME } from "@/components/AssetsEditor/constants";

export default function AssetsListDropGap({
  index,
  isTrailing = false,
  resolveAssetById,
  onInsertAssetsAt,
}) {
  const [isDragOver, setIsDragOver] = useState(false);

  // During dragover the browser exposes `dataTransfer.types` but NOT the
  // values, so this can only ever be a type check — reading the payload here
  // silently stops the gap accepting drags.
  const acceptsDrag = (event) => {
    const draggedTypes = [...event.dataTransfer.types];
    return draggedTypes.includes(ASSET_DRAG_MIME);
  };

  const handleDragOver = (event) => {
    if (!acceptsDrag(event)) return;

    event.preventDefault();
    // The assets panel behind us would also handle this as an upload/move.
    event.stopPropagation();
    event.dataTransfer.dropEffect = "copy";
    setIsDragOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (event) => {
    if (!acceptsDrag(event)) return;

    event.preventDefault();
    event.stopPropagation();
    setIsDragOver(false);

    const droppedAssetIds = parseDroppedAssetIds(event);
    const droppedAssets = droppedAssetIds
      .map((assetId) => resolveAssetById(assetId))
      .filter(Boolean);

    if (droppedAssets.length === 0) return;

    onInsertAssetsAt({ index, assets: droppedAssets });
  };

  const widthClass = isTrailing ? "flex-1 min-w-16" : "w-3";
  const indicatorAlignClass = isTrailing ? "justify-start" : "justify-center";

  return (
    <div
      id={`AssetsList__dropGap-${index}`}
      className={`AssetsList__dropGap self-stretch h-full flex ${indicatorAlignClass} ${isTrailing ? "" : "shrink-0"} ${widthClass}`}
      onDragOver={handleDragOver}
      onDragEnter={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}>
      <div
        className={`h-full w-1.5 rounded-full transition-colors ${isTrailing ? "ml-2" : ""} ${isDragOver ? "bg-primary" : "bg-transparent"}`}
      />
    </div>
  );
}

/**
 * @input DragEvent carrying '["a1","a2"]'
 * @output ['a1', 'a2']
 */
function parseDroppedAssetIds(event) {
  const raw = event.dataTransfer.getData(ASSET_DRAG_MIME);
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((assetId) => typeof assetId === "string");
  } catch {
    return [];
  }
}
